import {observeAdd, selectDoc, selectArr, event, asyncForEach} from "../utils/utils";
import {initSlider} from "../helpers/service.slider";

const props = {
    pageContainer: selectDoc('#PageContainer'),
    mainContainer: selectDoc('.yotpo-module'),
    emptyReviews: selectDoc('.yotpo-module .empty-reviews'),
    title: selectDoc('.yotpo-module .title'),
    sliderReady: false,
    sliderControls: selectDoc(`.ws-yotpo-slider .slider-controls`),
    sliderSprite: selectDoc(`.ws-yotpo-slider #glide-sprite`),
    writeReview: selectDoc('#write-review')
}

const initWriteReview = () => {
    if (props.writeReview) {
        event(props.writeReview, 'click', function () {
            let     yotpoButton = selectDoc('.write-review-button');
            if (yotpoButton) {
                yotpoButton.click()
                let fullNameLabel = selectDoc('label[for="yotpo_input_review_username"]');
                if (fullNameLabel) {
                    fullNameLabel.innerHTML = 'Your Name:'
                }

                let headerLabel = selectDoc('.y-label.yotpo-header-title');
                if (headerLabel) {
                    headerLabel.innerHTML = 'Write a Review '
                }
            }
        })
    }
}

const initYotpoSlider = async () => {
    const sliderResponsive = (glider, totalReviews) => {
        //Remove slider nav if less than limit
        let limit = 2;
        if (props.pageContainer.getBoundingClientRect().width < 768) {
            limit = 1;
        }
        if (totalReviews <= limit) {
            if (props.sliderSprite) {
                props.sliderSprite.style.display = 'none'
            }
            if (props.sliderControls) {
                props.sliderControls.style.display = 'none'
            }
        } else {
            if (props.sliderSprite) {
                props.sliderSprite.style.display = 'flex'
            }
            if (props.sliderControls) {
                props.sliderControls.style.display = 'flex'
            }
        }
    }

    const appendSlider = (slider, reviews, apiReviews) => {
        if (((reviews.length + apiReviews.length) > 0) && (!props.sliderReady)) {
            if (props.emptyReviews) {
                props.emptyReviews.classList.add('hide')
            }
            if (props.sliderControls) {
                props.sliderControls.classList.add('show')
            }

            let stars = 0;
            reviews.map(review => {
                stars += selectArr('.yotpo-review-stars  .yotpo-icon-star', review).length;
                if (slider) {
                    slider.innerHTML += `<li class="glide__slide">${review.outerHTML}</li>`;
                }
            })

            apiReviews.map(review => {
                if (slider) {
                    let score = '';
                    for (let index = 0; index < review.score; index++) {
                        score += '<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>';
                    }
                    stars += review.score;

                    slider.innerHTML += `
                        <li class="glide__slide">
                            <div class="yotpo-review yotpo-regular-box" data-review-id="${review.id}">
                                <div class="yotpo-header yotpo-verified-user">
                                    <div class="yotpo-header-element">
                                        <span class="y-label yotpo-user-name yotpo-font-bold pull-left" aria-level="3">${review.user.display_name}</span>
                                        ${review.verified_buyer ? '<div class="label-with-tooltip pull-left" aria-level="3"><span class="y-label yotpo-user-title yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip">Verified Reviewer</span></div>' : ''}
                                        <div class="yotpo-clr"></div>
                                        <div class="yotpo-review-stars">${score}</div>
                                    </div>
                                </div>
                                <div class="yotpo-main">
                                    <div class="content-title yotpo-font-bold" role="heading" aria-level="3">${review.title}</div>
                                    <div class="yotpo-clr"></div>
                                    <div class="yotpo-review-wrapper">
                                        <span class="sr-only" id="${review.id}-ada-summary-text">Review by ${review.user.display_name}</span>
                                        <span class="sr-only" id="${review.id}-ada-title-text">${review.content}</span>
                                        <div class="content-review" id="${review.id}">${review.content}</div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    `;
                }
            });

            if ((reviews.length + apiReviews.length) > 1) {
                let glider = initSlider(`.ws-yotpo-slider`, {
                    perView: 2,
                    type: 'carousel',
                    startAt: 0,
                    gap: '55',
                    breakpoints: {
                        767: {
                            perView: 1,
                            gap: '0',
                            peek: {
                                before: 0,
                                after: 0
                            }
                        }
                    }
                }, true);

                event(window, 'resize', function () {
                    sliderResponsive(glider, (reviews.length + apiReviews.length))
                })
                sliderResponsive(glider, (reviews.length + apiReviews.length));

            } else {
                if (props.sliderSprite) {
                    props.sliderSprite.style.display = 'none'
                }
                if (props.sliderControls) {
                    props.sliderControls.style.display = 'none'
                }
            }

            if (props.title) {
                let avg = Math.ceil(stars / (reviews.length + apiReviews.length)),
                    starsAdded = 0;

                if (props.starsContainer) {
                    props.starsContainer.parentNode.removeChild(props.starsContainer)
                }
                props.starsContainer = document.createElement('span');
                props.starsContainer.className = 'yotpo-stars'
                // @ADA
                $(props.starsContainer).attr('role', 'img')
                const ariaLabel = `${avg} out of 5 stars`
                $(props.starsContainer).attr('aria-label', ariaLabel)

                for (let i = 0; i < avg; i++) {
                    starsAdded++;
                    props.starsContainer.innerHTML += ` <span class="yotpo-icon yotpo-icon-star"></span>`
                }
                let emptyStars = (5 - starsAdded);
                for (let i = 0; i < emptyStars; i++) {
                    props.starsContainer.innerHTML += `<span class="yotpo-icon yotpo-icon-empty-star"></span>`
                }

                props.title.appendChild(props.starsContainer);
                props.title.innerHTML += `<a href="#shopify-section-ws-yotpo-add" class="yotpo-sum-reviews">${(reviews.length + apiReviews.length)} ${(reviews.length + apiReviews.length) > 1 ? ' REVIEWS' : ' REVIEW'}</a>`;

                let productInfo = selectDoc('#toolbar .header .info');
                if (productInfo) {
                    productInfo.innerHTML += props.title.outerHTML;
                }
            }

            props.sliderReady = true;
        } else {
            if (!props.sliderReady) {
                if (props.emptyReviews) {
                    props.emptyReviews.classList.remove('hide')
                    props.emptyReviews.classList.add('show')
                }
                let sliderContainer = selectDoc('.ws-yotpo-slider');
                if (sliderContainer) {
                    sliderContainer.parentNode.removeChild(sliderContainer)
                }

                let productInfo = selectDoc('#toolbar .header .info');
                if (productInfo) {
                    productInfo.innerHTML += `<span class="title">
                                             <span class="yotpo-stars" role="img" aria-label="0 out of 5 stars">
                                                <span class="yotpo-icon yotpo-icon-empty-star"></span>
                                                <span class="yotpo-icon yotpo-icon-empty-star"></span>
                                                <span class="yotpo-icon yotpo-icon-empty-star"></span>
                                                <span class="yotpo-icon yotpo-icon-empty-star"></span>
                                                <span class="yotpo-icon yotpo-icon-empty-star"></span>
                                             </span>
                                             <a href="#shopify-section-ws-yotpo-add" class="yotpo-sum-reviews">
                                                0 REVIEWS
                                             </a>
                                          </span>`;
                }
            }
        }
    }

    let productDataVariants = selectArr('#product-custom-data data'),
        productID = selectDoc('.yotpo-main-widget').getAttribute('data-product-id'),
        filterVariants = productDataVariants.filter(variant => variant.getAttribute('data-id').replace('V','') !== productID),
        reviewsArr = [];
    if (filterVariants) {
        await asyncForEach(filterVariants, async (variant) => {
            try {
                let parentID = variant.getAttribute('data-id').replace('V','')
                let response = await fetch(`https://api.yotpo.com/v1/widget/5eJrxwpMjvVBBdJpDCZOBZLex9Q5Rnls3ygbm9rS/products/${parentID}/reviews.json`)
                let res = await response.json();
                res.response.reviews.map(review => {
                    reviewsArr.push(review)
                })
            } catch (e) {
                console.log(e)
                return false
            }
        })
    }

    /*let directReviews = await fetch(`https://api.yotpo.com/v1/widget/5eJrxwpMjvVBBdJpDCZOBZLex9Q5Rnls3ygbm9rS/products/${productID}/reviews.json`)
    let res = await directReviews.json();
    res.response.reviews.map(review => {
        reviewsArr.push(review)
    });*/

    appendSlider(
        selectDoc('.ws-yotpo-slider ul.glide__slides', props.mainContainer),
        selectArr('.yotpo-review.yotpo-regular-box'),
        reviewsArr)
}

const initializer = () => {
    // initYotpoSlider()
    initWriteReview()
}

export const Yotpo = {
    init: () => initializer()
}
